import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'

export default {
    get () {
        return axios.get(`${process.env.VUE_APP_BASE_URL}Tag`, AUTH_HEADERS())
    },
    getById (id) {
        return axios.get(`${process.env.VUE_APP_BASE_URL}Tag/${id}`, AUTH_HEADERS())
    },
    create(tag) {
        return axios.post(`${process.env.VUE_APP_BASE_URL}Tag/`, tag, AUTH_HEADERS())
    },
    update(id, tag) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}Tag/update/${id}`, {id: id, tag: tag}, AUTH_HEADERS())
    },
    delete(id) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}Tag/delete/${id}`, id, AUTH_HEADERS())
    },

}
